import { render, staticRenderFns } from "./ClassTeacherWork.vue?vue&type=template&id=4db4c796&scoped=true"
import script from "./ClassTeacherWork.vue?vue&type=script&lang=js"
export * from "./ClassTeacherWork.vue?vue&type=script&lang=js"
import style0 from "./ClassTeacherWork.vue?vue&type=style&index=0&id=4db4c796&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4c796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db4c796')) {
      api.createRecord('4db4c796', component.options)
    } else {
      api.reload('4db4c796', component.options)
    }
    module.hot.accept("./ClassTeacherWork.vue?vue&type=template&id=4db4c796&scoped=true", function () {
      api.rerender('4db4c796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/WorkOverview/MoralEducation/components/ClassTeacherWork.vue"
export default component.exports